module.exports = __webpack_public_path__ + "img/momo_button_update.bd8f5f4e.png";